import { useState } from "react";
import TabNavigation from "../../components/Settings/tab-navigation";
import PersonalTab from "../../components/Settings/personal-tab";
import OrganizationTab from "../../components/Settings/organization-tab";
import UsageTab from "../../components/Settings/usage-tab";
import { TopBar } from "../../components/CommonComponent/Topbar";

export default function Settings() {
  const [activeTab, setActiveTab] = useState("Personal");
  const tabs = ["Personal", "Organization", "Usage"];

  const isOrganizer =localStorage.getItem("isOrganizer");
  console.log(isOrganizer)

  if(isOrganizer =="false"){
      tabs.splice(1,1);
  }

  const renderActiveTab = () => {
    switch (activeTab) {
      case "Personal":
        return <PersonalTab />;
      case "Organization":
        return <OrganizationTab />;
      case "Usage":
        return <UsageTab />;
      default:
        return <PersonalTab />;
    }
  };

  return (
    <div>
      <TopBar text="Settings" />
      <div className="py-8 px-8">
        <div className="p-4 bg-white">
          <TabNavigation
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabs={tabs}
          />
          {renderActiveTab()}
        </div>
      </div>
    </div>
  );
}
